import { createAction, props } from '@ngrx/store';
import { Car } from 'src/app/public/car/models/car.model';
import { CarDocumentType } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';


export class FilesActions {

    public static uploadCarImageSubmit = createAction(
        '[Files API] Upload Car Image Submit',
        props <{ carId: string, file: File }> ()
    );

    public static uploadCarDocumentSubmit = createAction(
        '[Files API] Upload Car Document Submit',
        props <{ carId: string, file: File }> ()
    );

    public static convertDocumentSubmit = createAction(
        '[Files API] Convert Document Submit',
        props <{ carDocumentType: CarDocumentType, file: File }> ()
    );


    public static uploadCarImageSuccess = createAction(
        '[Files API] Upload Car Image Success',
        props <{ carId: string, filename: string }> ()
    );

    public static uploadCarDocumentSuccess = createAction(
        '[Files API] Upload Car Document Success',
        props <{ carId: string, filename: string }> ()
    );

    public static convertDocumentSuccess = createAction(
        '[Files API] Convert Document Success',
        props <{ carDocumentType: CarDocumentType, file: File, content: string }> ()
    );

    public static uploadCarImageFileDataSuccess = createAction(
        '[Files API] Upload Car Image FileData Success',
        props <{ car: Car }> ()
    );

    public static uploadCarDocumentFileDataSuccess = createAction(
        '[Files API] Upload Car Document FileData success',
        props <{ car: Car }> ()
    );
    
    public static fetchCarImageSubmit = createAction(
        '[Files API] Fetch Car Image Submit',
        props <{ carId: string, filename: string }> ()
    );

    public static fetchCarDocumentSubmit = createAction(
        '[Files API] Fetch Car Document Submit',
        props <{ carId: string, filename: string }> ()
    );

    public static fetchCarImageSampleSubmit = createAction(
        '[Files API] Fetch Car Image Sample Submit',
        props <{ filename: string }> ()
    );

    public static fetchCarImageSuccess = createAction(
        '[Files API] Fetch Car Image Success',
        props <{ carId: string, imageDatas: FileData }> ()
    );

    public static fetchCarDocumentSuccess = createAction(
        '[Files API] Fetch Car Document Success',
        props <{ carId: string, documentDatas: FileData }> ()
    );

    public static fetchCarImageSampleSuccess = createAction(
        '[Files API] Fetch Car Image Sample Success',
        props <{ filename: string, blob: Blob }> ()
    );

    public static imageFetchError = createAction(
        '[Files API Error] image fetch Error',
        props <{ errorMessage: string }> ()
    );

    public static documentFetchError = createAction(
        '[Files API Error] document fetch Error',
        props <{ errorMessage: string }> ()
    );

}
